import * as React from "react";
import { Box, Image } from "grommet";
export const LoadingImage = () => (
  <Box height="small" width="small" align="center">
    <Image
      src="https://i.ya-webdesign.com/images/peach-svg-animated-6.gif"
      height="auto"
      width="200px"
    />
  </Box>
);
